import React, {useEffect, useRef, useState} from "react";
import { motion, useMotionValue, useTransform, useSpring, AnimatePresence} from 'framer-motion';
import { liVariants } from "./variants";
import './archivelistitem.css';
import { primaryInput } from "detect-it";


const ArchiveListItem = ({item, activeIdx, idx, activeFilter, archiveElementRefs, onMouseEnter, onMouseLeave, handleEleClicked, isProjectExit, isFiltered, isPresent}) => {

    const [isHovering, setIsHovering] = useState(false);
    const strikethroughRef = useRef(null);
    const [runTimeString, setrunTimeString] = useState(null);
    const customHandleEnter = () => {
        setIsHovering(true);
        if(activeIdx !== idx){
            // if we arent the active index, i.e. we have just entered a new item
            // we need to activate the 'selecting' state
        }
        onMouseEnter()
    }

    const customHandleLeave = () => {
        setIsHovering(false);
        onMouseLeave();
    }

    const bgSlider = {
        initial: {
            transform: "scale3d(0, 1, 1)"
        }, animate: {   
            transform: "scale3d(1, 1, 1)",
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1]
            }
        }, exit: {
            transform: "scale3d(0, 1, 1)",
            transition: {
                duration: 0.3
            
            }
        }, exitFast: {
            transform: "scale3d(0, 1, 1)",
            opacity: 0,
            transition: {duration: 0}
        }
    }

    useEffect(() => {
        if(isFiltered){
            try{
                archiveElementRefs.current[idx].classList.add("p_filtered");
            } catch{}
        } else{
            try{
                archiveElementRefs.current[idx].classList.remove("p_filtered");
            } catch{}
        }
    }, [isFiltered])

    useEffect(() => {
        try{
            if(item.meta){
                let firstPrepend = '';
                if(item.meta.runTime[0]<10)
                    firstPrepend = '0'
                let secondPrepend = ''
                if(item.meta.runTime[1]<10)
                    secondPrepend = '0'
                let tmpNew = firstPrepend+item.meta.runTime[0]+":"+secondPrepend+item.meta.runTime[1];
                setrunTimeString(tmpNew)
            }
        } catch{}
    }, [])

    return(
        <motion.div 
            className="archv_it"
            style={{
                position: "relative", 
                width: "100%",
                display: "flex",
                overflow: "hidden"
            }}
            initial="initial"    
            animate={isPresent ? "animate" : "defaultExit"}
            exit="exit"    
            onMouseEnter={(e) => {
                try{
                    let test = document.getElementById('cursor-circle');
                    test.classList.add("cursor-active")
                }
                catch{

                }
            }}
            onMouseLeave={(e) => {
                try{
                    let test = document.getElementById('cursor-circle');
                    test.classList.remove("cursor-active")
                }
                catch{

                }
            }}
        >
            {/* <div
                className="archv_strike__wrapper"
                ref={strikethroughRef}
            /> */}
            <motion.div
                className="a_li_wrapper"
                ref={el => archiveElementRefs.current[idx] = el}
                variants={liVariants}
                onMouseEnter={customHandleEnter}
                onMouseLeave={customHandleLeave}
                onClick={() => {handleEleClicked(idx)}}
                custom={[isProjectExit, idx]}
            >
                <div className="li_first_col">
                    <div className="li_number_wrap mix-dif">
                    <AnimatePresence>
                        {(isHovering || (activeIdx == idx)) &&
                            <motion.div
                                className="bg-slider sldr-l bg-slide-hov mix-dif"
                                initial={"initial"}
                                animate={"animate"}
                                exit={"exit"}
                                variants={bgSlider}
                            />
                        }
                    </AnimatePresence>
                        <span style={{paddingLeft: "20px"}}>[</span>
                        <span>{idx < 9 ? '0' : ''}{idx+1}</span>
                        <span style={{paddingRight: "20px"}}>]</span>
                    </div>
                </div>
                <div className="p_n">{item.title}</div>
                <div className="p-an">{item.artist}</div>
                <div className="p-loc">{item.location}</div>
                <div className="li_last_col">
                    <div className="p_rt">
                        <AnimatePresence>
                            {(isHovering || (activeIdx == idx)) ?
                                <motion.div
                                    className="bg-slider sldr-r bg-slide-hov mix-dif"
                                    initial={"initial"}
                                    animate={"animate"}
                                    exit={"exit"}
                                    variants={bgSlider}
                                />
                                : <React.Fragment />
                            }
                        </AnimatePresence>
                        {runTimeString}
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
} 

export default ArchiveListItem;